export default [
  {
    path: "subscriber-subscription-report",
    name: "subscribersubscriptionreport",
    component: () =>
      import(
        /* webpackChunkName: "AddSingleSubscriber" */ "../pages/subscriberSubscriptionReport/SubscriberSubscriptionReport.vue"
      ),
    meta: {
      title: `Subscription Report`,
    },
  },
];
